window.FabricBridge = window.FabricBridge || {};

/* ==========================================
   HELPERS
========================================== */

window.FabricBridge.sleep = ms =>
  new Promise(resolve => setTimeout(resolve, ms));

window.FabricBridge.getCart = async () => {
  return fetch('/cart.js', {
    credentials: 'same-origin',
    cache: 'no-store'
  }).then(r => r.json());
};

/* ==========================================
   CART BUBBLE
========================================== */

window.FabricBridge.updateCartBubble = count => {
  document.querySelectorAll('.cart-bubble').forEach(bubble => {
    bubble.classList.toggle('visually-hidden', count <= 0);
  });

  document.querySelectorAll('.cart-bubble__text-count').forEach(el => {
    el.textContent = count;

    if (count > 0) {
      el.hidden = false;
      el.removeAttribute('hidden');
      el.removeAttribute('aria-hidden');
      el.classList.remove('hidden');
      el.style.display = '';
      el.style.visibility = 'visible';
      el.style.opacity = '1';
    } else {
      el.classList.add('hidden');
      el.setAttribute('aria-hidden', 'true');
    }
  });

  document.querySelectorAll('cart-icon').forEach(icon => {
    icon.classList.toggle(
      'header-actions__cart-icon--has-cart',
      count > 0
    );
  });
};

/* ==========================================
   EVENTS
========================================== */

window.FabricBridge.dispatchCartEvents = cart => {
  document.dispatchEvent(
    new CustomEvent('fabric:cart-updated', {
      detail: { cart }
    })
  );

  document.dispatchEvent(
    new CustomEvent('cart:updated', {
      detail: cart
    })
  );

  document.dispatchEvent(
    new CustomEvent('cart:refresh', {
      detail: cart
    })
  );
};

/* ==========================================
   REFRESH DRAWER SECTION
========================================== */

window.FabricBridge.refreshDrawer = async () => {
  try {
    const sections = await fetch(
      '/?sections=cart-drawer-section',
      { cache: 'no-store' }
    ).then(r => r.json());

    const current = document.querySelector(
      '#shopify-section-cart-drawer-section'
    );

    const html = sections['cart-drawer-section'];

    if (!current || !html) return;

    const doc = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    const replacement = doc.querySelector(
      '#shopify-section-cart-drawer-section'
    );

    if (replacement) {
      current.replaceWith(replacement);
    }
    document.dispatchEvent(
  new CustomEvent('theme:section:loaded')
);
  } catch (err) {
    console.error('[FabricBridge] refreshDrawer', err);
  }
};

/* ==========================================
   REFRESH CART
========================================== */

window.FabricBridge.refreshCart = async () => {
  try {
    const cart =
      await window.FabricBridge.getCart();

    window.FabricBridge.updateCartBubble(
      cart.item_count
    );

    window.FabricBridge.dispatchCartEvents(
      cart
    );

    return cart;
  } catch (err) {
    console.error('[FabricBridge]', err);
  }
};

/* ==========================================
   OPEN DRAWER
========================================== */

window.FabricBridge.openCartDrawer = async () => {
  try {
    // Atualiza em paralelo
    const [cart] = await Promise.all([
      window.FabricBridge.refreshCart(),
      window.FabricBridge.refreshDrawer()
    ]);

    const trigger = document.querySelector(
      '[aria-controls="cart-drawer"]'
    );

    if (trigger) {
      requestAnimationFrame(() => {
        trigger.click();
      });
      return;
    }

    document.body.classList.add(
      'page-wrapper--drawer-open'
    );

    document.dispatchEvent(
      new CustomEvent('cart:open')
    );

  } catch (err) {
    console.error('[FabricBridge]', err);
  }
};